<template>
  <div>
    <div class="footer__lineup">
      <h2 class="footer__lineup__title">シトロエンモデルラインナップ</h2>
      <div class="footer__lineup__wrap">
        <div class="footer__lineup__item">
          <div class="footer__lineup__item__img">
            <img src="/common/img/footer-lineup-c5aircross.png" alt="" />
          </div>
          <h3 class="footer__lineup__item__model">NEW C5 AIRCROSS SUV</h3>
          <a
            class="footer__lineup__item__link"
            target="_blank"
            href="https://www.citroen.jp/car/c5aircross/"
            onclick="kpp_tracking_event('Footer','common','Redirection::Showroom::1CCESY',false,false,'newgtm');"
          >
            詳しく見る
            <svg
              class="footer__lineup__item__link--arrow"
              version="1.1"
              viewBox="0 0 9 15"
            >
              <path
                d="M857.425,1451.46a23.922,23.922,0,0,1-5.418,5.33l1.854,2.21a28.569,28.569,0,0,0,7.031-7.17,0.675,0.675,0,0,0,.1-0.37,0.785,0.785,0,0,0-.1-0.37,29.093,29.093,0,0,0-6.928-7.09l-1.908,2.26A24.091,24.091,0,0,1,857.425,1451.46Z"
                transform="translate(-852 -1444)"
              ></path>
            </svg>
          </a>
        </div>
        <div class="footer__lineup__item">
          <div class="footer__lineup__item__img">
            <img src="/common/img/footer-lineup-c4space.png" alt="" />
          </div>
          <h3 class="footer__lineup__item__model">GRAND C4 SPACETOURER</h3>
          <a
            class="footer__lineup__item__link"
            target="_blank"
            href="https://www.citroen.jp/car/grand-c4-spacetourer/"
            onclick="kpp_tracking_event('Footer','common','Redirection::Showroom::1CH5CL',false,false,'newgtm');"
          >
            詳しく見る
            <svg
              class="footer__lineup__item__link--arrow"
              version="1.1"
              viewBox="0 0 9 15"
            >
              <path
                d="M857.425,1451.46a23.922,23.922,0,0,1-5.418,5.33l1.854,2.21a28.569,28.569,0,0,0,7.031-7.17,0.675,0.675,0,0,0,.1-0.37,0.785,0.785,0,0,0-.1-0.37,29.093,29.093,0,0,0-6.928-7.09l-1.908,2.26A24.091,24.091,0,0,1,857.425,1451.46Z"
                transform="translate(-852 -1444)"
              ></path>
            </svg>
          </a>
        </div>
        <div class="footer__lineup__item">
          <div class="footer__lineup__item__img">
            <img src="/common/img/footer-lineup-c3aircross.png" alt="" />
          </div>
          <h3 class="footer__lineup__item__model">C3 AIRCROSS SUV</h3>
          <a
            class="footer__lineup__item__link"
            target="_blank"
            href="https://www.citroen.jp/car/c3-aircross/"
            onclick="kpp_tracking_event('Footer','common','Redirection::Showroom::1CW8AF',false,false,'newgtm');"
          >
            詳しく見る
            <svg
              class="footer__lineup__item__link--arrow"
              version="1.1"
              viewBox="0 0 9 15"
            >
              <path
                d="M857.425,1451.46a23.922,23.922,0,0,1-5.418,5.33l1.854,2.21a28.569,28.569,0,0,0,7.031-7.17,0.675,0.675,0,0,0,.1-0.37,0.785,0.785,0,0,0-.1-0.37,29.093,29.093,0,0,0-6.928-7.09l-1.908,2.26A24.091,24.091,0,0,1,857.425,1451.46Z"
                transform="translate(-852 -1444)"
              ></path>
            </svg>
          </a>
        </div>
        <div class="footer__lineup__item">
          <div class="footer__lineup__item__img">
            <img src="/common/img/footer-lineup-c3.png" alt="" />
          </div>
          <h3 class="footer__lineup__item__model">C3</h3>
          <a
            class="footer__lineup__item__link"
            target="_blank"
            href="https://www.citroen.jp/car/c3/"
            onclick="kpp_tracking_event('Footer','common','Redirection::Showroom::1CB6A5',false,false,'newgtm');"
          >
            詳しく見る
            <svg
              class="footer__lineup__item__link--arrow"
              version="1.1"
              viewBox="0 0 9 15"
            >
              <path
                d="M857.425,1451.46a23.922,23.922,0,0,1-5.418,5.33l1.854,2.21a28.569,28.569,0,0,0,7.031-7.17,0.675,0.675,0,0,0,.1-0.37,0.785,0.785,0,0,0-.1-0.37,29.093,29.093,0,0,0-6.928-7.09l-1.908,2.26A24.091,24.091,0,0,1,857.425,1451.46Z"
                transform="translate(-852 -1444)"
              ></path>
            </svg>
          </a>
        </div>
      </div>
    </div>
    <footer class="footer">
      <div class="footer__wrap">
        <div class="footer__sns">
          <ul class="footer__sns__wrap">
            <li class="footer__sns__item">
              <a
                href="https://www.facebook.com/Citroen.Japon"
                class="footer__sns__item__link"
                style="background-image: url(/common/img/icon_facebook.png);"
                target="_blank"
              ></a>
            </li>
            <li class="footer__sns__item">
              <a
                href="https://twitter.com/CITROEN_JP"
                class="footer__sns__item__link"
                style="background-image: url(/common/img/icon_twitter.png);"
                target="_blank"
              ></a>
            </li>
            <li class="footer__sns__item">
              <a
                href="https://www.youtube.com/user/CITROENjpOfficial"
                class="footer__sns__item__link"
                style="background-image: url(/common/img/icon_youtube.png);"
                target="_blank"
              ></a>
            </li>
            <li class="footer__sns__item">
              <a
                href="https://www.instagram.com/citroen_jp/"
                class="footer__sns__item__link"
                style="background-image: url(/common/img/icon_insta.png);"
                target="_blank"
              ></a>
            </li>
          </ul>
        </div>
        <div class="footer__copy">
          <span class="footer__copy__item--ds"
            >シトロエン公式サイト
            <a
              target="_blank"
              class="footer__copy__item__link"
              href="https://www.citroen.jp/home.html"
            >
              www.citroen.jp</a
            ></span
          >
          <span class="footer__copy__item--rights"
            >Copyright © Groupe PSA Japan Co., Ltd. All rights reserved.</span
          >
        </div>
      </div>
    </footer>
  </div>
</template>
<script>
export default {
  name: "global-footer",
};
</script>
<style lang="scss"></style>
